export default {
  library: [],
  categories: [],
  document: {},
  structure: [],
  flatStructure: [],
};
